module.exports = __webpack_public_path__ + "static/media/analytics_main.c1a7c718.png";